import styled from "@emotion/styled";
import { BaseCell } from "./BaseCell";
import type { ReactElement } from "react";

const Container = styled(BaseCell)<{ flex: number }>`
  color: rgba(49, 57, 74, 1);
  flex: ${(props) => props.flex};
  font-size: 14px;
`;

const Push = styled.div`
  content: " ";
  width: 40px;
`;

const IconWrapper = styled.div`
  margin-left: 6px;
`;

export const HeaderCell = ({
  title,
  icon,
}: {
  title?: string;
  icon?: ReactElement;
}) => {
  // This is bad, and I'm ashamed
  const isWide = title && ["Name", "File name", "Lender"].includes(title);
  return (
    <Container flex={isWide ? 2 : 1}>
      {title === "Name" && <Push />}
      {title}
      {<IconWrapper>{icon}</IconWrapper>}
    </Container>
  );
};
